// 统一请求封装：处理 {code, data, message} 协议
const BASE = import.meta.env.VITE_API_BASE || '/api';

export interface ApiOk<T> { code: 0; data: T; message?: string }
export interface ApiErr  { code: number; message: string; data?: unknown }

export class ApiException extends Error {
  code: number;
  data?: unknown;
  constructor(code: number, message: string, data?: unknown) { super(message); this.code = code; this.data = data; }
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(BASE + path, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init.headers || {}) },
    ...init
  });
  const json = await res.json().catch(() => ({ code: -1, message: '网络异常' }));
  if (json.code === 0) return json.data as T;
  throw new ApiException(json.code ?? -1, json.message ?? '请求失败', json.data);
}

export const http = {
  get:    <T>(p: string)              => request<T>(p),
  post:   <T>(p: string, body?: unknown) => request<T>(p, { method: 'POST',   body: JSON.stringify(body ?? {}) }),
  patch:  <T>(p: string, body?: unknown) => request<T>(p, { method: 'PATCH',  body: JSON.stringify(body ?? {}) }),
  delete: <T>(p: string, body?: unknown) => request<T>(p, { method: 'DELETE', body: JSON.stringify(body ?? {}) })
};
